import { FrameworkDataTable } from 'framework-data-table';
import styled from 'styled-components';
import { useIsPillBorderRadius } from 'portals-platform-lib';
import { Flex } from 'foundations-components/components/Flex';
import { TablePaginator } from './TablePaginator';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DEFAULT_PAGE_SIZE = 25;
const StyledTableWrapper = styled.div.withConfig({
  displayName: "PaginatedDataTable__StyledTableWrapper"
})(({
  theme,
  $isUsingPillBorderRadius
}) => ({
  overflowX: 'auto',
  th: {
    backgroundColor: `${theme.color['fill-accent-neutral-subtle']} !important`
  },
  '[data-test-id="framework-data-table-container"] > div': {
    borderRadius: `${$isUsingPillBorderRadius ? theme.borderRadius['0'] : theme.borderRadius['300']} !important`
  }
}));
export function PaginatedDataTable({
  columns,
  rows,
  getRowId,
  loading,
  currentPage,
  hasMore,
  hasPrev,
  onNextPage,
  onPrevPage,
  sorts,
  onSortsChange,
  RowComponent,
  totalResultsCount
}) {
  const isPill = useIsPillBorderRadius();
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    gap: "300",
    children: [/*#__PURE__*/_jsx(StyledTableWrapper, {
      $isUsingPillBorderRadius: isPill,
      children: /*#__PURE__*/_jsx(FrameworkDataTable, {
        columns: columns,
        rows: rows,
        getRowId: getRowId,
        RowComponent: RowComponent,
        sortable: true,
        sorts: sorts,
        onSortsChange: ({
          nextSorts
        }) => onSortsChange === null || onSortsChange === void 0 ? void 0 : onSortsChange(nextSorts),
        pageable: false,
        reorderable: false,
        resizable: false,
        selectable: false,
        hasGate: () => false,
        hasScope: () => false,
        loading: loading
      })
    }), /*#__PURE__*/_jsx(TablePaginator, {
      currentPage: currentPage,
      hasMore: hasMore,
      hasPrev: hasPrev,
      onNextPage: onNextPage,
      onPrevPage: onPrevPage,
      loading: loading,
      totalResultsCount: totalResultsCount,
      pageSize: DEFAULT_PAGE_SIZE
    })]
  });
}